import { render } from "./candidates-table.vue?vue&type=template&id=4f693506"
import script from "./candidates-table.vue?vue&type=script&lang=js"
export * from "./candidates-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__